import axios from 'axios';

const closeUserAccountApi = async (values, token, langIsoCode) => {
  try {
    const res = await axios.post('/closeAccount/temporary', values, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default closeUserAccountApi;
